import React from "react";
import { FileText, Download, CheckCircle, ExternalLink } from "lucide-react";
import "./ResumeCTA.css";

const ResumeCTA = () => {
  return (
    <section className="resume-cta-section">
      <div className="container">
        
        <div className="resume-cta-card">
          <div className="resume-cta-content">
            <span className="badge badge-terracotta">Authoritative Document</span>
            
            <h3 className="resume-cta-title">
              Looking for Prem's Complete <em>Engineering Resume</em>?
            </h3>
            
            <p className="resume-cta-description">
              Download the authoritative, ATS-friendly single-source resume PDF covering full-stack &amp; backend software engineering, production ERP/CRM platforms, and technical competency clusters.
            </p>

            <div className="resume-cta-highlights">
              <div className="resume-hl-item">
                <CheckCircle size={14} className="hl-icon" />
                <span>Full Stack &amp; Backend Engineering</span>
              </div>
              <div className="resume-hl-item">
                <CheckCircle size={14} className="hl-icon" />
                <span>ERP, CRM &amp; LMS Systems</span>
              </div>
              <div className="resume-hl-item">
                <CheckCircle size={14} className="hl-icon" />
                <span>ATS-Compliant Structure</span>
              </div>
            </div>
          </div>

          <div className="resume-cta-actions">
            <a
              href="/resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-accent resume-download-main-btn"
            >
              <FileText size={18} />
              <span>View Resume (PDF)</span>
            </a>
            
            <a
              href="/resume.pdf"
              download="Prem_Gore_Resume.pdf"
              className="btn btn-outline resume-preview-btn"
            >
              <Download size={16} />
              <span>Download PDF</span>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ResumeCTA;
